/*
 * Module detects selected variants and stores them into sessionStorage.
 * sessionStorage is used over localStorage so that the data is deleted when the window is closed.
 * When directing the product's size pages, retrieves the selected variants from sessionStorage and pre-selects them.
 */

class VariantSizeSelector {
  constructor() {
    this.updateVariantData();
    this.selectVariantsFromSessionStorage();
  }

  updateVariantData() {
    const sizeSelectorContainer = document.getElementById('ProductSizeSelector');

    if (!sizeSelectorContainer) {
      return;
    }

    const productsToApplyTo = JSON.parse(sizeSelectorContainer.dataset.products);

    document.addEventListener('variant:change', (evt) => {
      const variant = evt.detail.variant;
      if (evt.detail.variant === null) {
        return;
      }
      const variantData = {
        option1: variant.option1 || null,
        option2: variant.option2 || null,
        option3: variant.option3 || null,
        products: productsToApplyTo,
      };

      sessionStorage.setItem('variantData', JSON.stringify(variantData));
    });
  }

  selectVariantsFromSessionStorage() {
    const variantData = JSON.parse(sessionStorage.getItem('variantData'));
    const productForm = document.querySelector('[id^="AddToCartForm-"]');
    if (!productForm) {
      return;
    }

    const currentProduct = productForm.dataset.productHandle;

    if (variantData === null || !variantData.products.includes(currentProduct)) {
      return;
    }


    const option1 = variantData.option1 || null;
    const option2 = variantData.option2 || null;
    const option3 = variantData.option3 || null;
    let option1Variant = null;
    let option2Variant = null;
    let option3Variant = null;

    const productVariants = Array.from(document.querySelectorAll('fieldset.variant-input-wrap'));

    if (productVariants[0]) {
      const options = Array.from(productVariants[0].querySelectorAll('input'));
      option1Variant = options.find(((input) => input.value === option1)) || null;
      elementToggleState(option1Variant, option1, 'option1');
    }

    if (productVariants[1]) {
      const options = Array.from(productVariants[1].querySelectorAll('input'));
      option2Variant = options.find(((input) => input.value === option2)) || null;
      elementToggleState(option2Variant, option2, 'option2');
    }

    if (productVariants[2]) {
      const options = Array.from(productVariants[2].querySelectorAll('input'));
      option3Variant = options.find(((input) => input.value === option3)) || null;
      elementToggleState(option3Variant, option3, 'option3');
    }

    option1Variant.classList.add('awesome-find');

    document.dispatchEvent(new CustomEvent('variantChange'));

    // document.querySelectorAll('fieldset.variant-input-wrap').forEach((variant) => {
    //   variant.addEventListener('variantsSelected', () => {
    //     console.log('variantsSelected event fired');
    //     console.log(variant);
    //   });
    // });
  }
}

function elementToggleState(element, value) {
  const event = new Event('change');
  if (!element) {
    return;
  }

  element.classList.add('element-triggered');
  // console.log(element);
  // console.log(element.tagName);
  if (element.tagName === 'INPUT') {
    // console.log('input');
    element.checked = true;
  } else {
    // console.log('select');
    element.value = value;
  }

  element.dispatchEvent(event);
}

export default VariantSizeSelector;
